



























import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    small: Boolean,
    leftOriented: Boolean
  }
})
export default class ActionBtn extends Vue {
  reemitClickEvent() {
    this.$emit("click");
  }
}
